import React, { useEffect, useRef, useState } from "react";
import { Wrapper } from "@googlemaps/react-wrapper";
import appConfig from "@appConfig";
import { getOperationLabel } from "./etapas";

const MARKERS = {
    operation: {
        url: "http://maps.google.com/mapfiles/ms/icons/green-dot.png",
        emoji: "🟢"
    },
    angel: {
        url: "http://maps.google.com/mapfiles/ms/icons/blue-dot.png",
        emoji: "🔵"
    }
};

const formatAddress = (addr) => {
    if (!addr) return "";
    const parts = [
        addr.address,
        addr.address_number,
        addr.neighborhood,
        addr.city,
        addr.country_state
    ].filter(Boolean);
    return parts.join(", ");
};

const parseCoord = (value) => {
    if (value === null || value === undefined || value === "") return null;
    const num = parseFloat(value);
    return Number.isNaN(num) ? null : num;
};

const MapInstance = ({ pins }) => {
    const ref = useRef(null);
    const [map, setMap] = useState();

    useEffect(() => {
        if (ref.current && !map && pins.length > 0) {
            setMap(
                new window.google.maps.Map(ref.current, {
                    center: pins[0].position,
                    zoom: 15,
                    disableDefaultUI: true,
                    zoomControl: true,
                })
            );
        }
    }, [ref, map, pins]);

    useEffect(() => {
        if (!map || pins.length === 0) return;

        const bounds = new window.google.maps.LatLngBounds();
        const infoWindow = new window.google.maps.InfoWindow();

        pins.forEach(pin => {
            const marker = new window.google.maps.Marker({
                position: pin.position,
                map,
                title: pin.title,
                icon: pin.icon,
            });

            if (pin.description) {
                marker.addListener("click", () => {
                    infoWindow.setContent(
                        `<div style="font-size:12px;max-width:220px">
                            <strong>${pin.title}</strong><br/>
                            ${pin.description}
                        </div>`
                    );
                    infoWindow.open(map, marker);
                });
            }

            bounds.extend(pin.position);
        });

        if (pins.length > 1) {
            map.fitBounds(bounds, 80);
        } else {
            map.setCenter(pins[0].position);
            map.setZoom(15);
        }
    }, [map, pins]);

    return <div ref={ref} style={{ width: "100%", height: "180px", borderRadius: "8px" }} />;
};

const MiniMap = ({ evidencia }) => {
    const GMAPS_API_KEY = appConfig.mapsKey;

    if (!evidencia) {
        return <EmptyState message="Localização indisponível." />;
    }

    const etapa = (evidencia.etapa || "").toUpperCase();
    const operationAddress = evidencia.endereco_operacao;

    const pins = [];

    const opLat = parseCoord(operationAddress?.latitude);
    const opLng = parseCoord(operationAddress?.longitude);
    if (opLat !== null && opLng !== null) {
        pins.push({
            position: { lat: opLat, lng: opLng },
            title: getOperationLabel(etapa),
            description: formatAddress(operationAddress),
            icon: MARKERS.operation.url,
        });
    }

    const angelLat = parseCoord(evidencia.latitude);
    const angelLng = parseCoord(evidencia.longitude);
    if (angelLat !== null && angelLng !== null) {
        pins.push({
            position: { lat: angelLat, lng: angelLng },
            title: "Localização do Angel",
            description: "Posição registrada no atendimento",
            icon: MARKERS.angel.url,
        });
    }

    if (pins.length === 0) {
        return <EmptyState message="Coordenadas indisponíveis para esta etapa." />;
    }

    return (
        <div style={{ width: "100%" }}>
            <Wrapper apiKey={GMAPS_API_KEY}>
                <MapInstance pins={pins} />
            </Wrapper>

            <div style={{ display: 'flex', gap: '16px', marginTop: '8px', fontWeight: 200, flexWrap: 'wrap', fontSize: '12px' }}>
                {operationAddress && (
                    <span style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                        {MARKERS.operation.emoji} {getOperationLabel(etapa)}
                    </span>
                )}
                <span style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                    {MARKERS.angel.emoji} Localização do Angel
                </span>
            </div>
        </div>
    );
};

const EmptyState = ({ message }) => (
    <div style={{ padding: '16px', color: '#6A7181', fontSize: '14px' }}>
        {message}
    </div>
);

export default MiniMap;